<lb-profile-info-box infoBoxIcon="untitled-ui/files/file-02" [formGroup]="form()">
	<ng-content right>
		<lb-form-row>
			<lb-form-field>
				<label>Bio</label>
				<textarea md-form-input formControlName="bio" rows="8"></textarea>
			</lb-form-field>
		</lb-form-row>
	</ng-content>
</lb-profile-info-box>
